export default __webpack_public_path__ + "static/11-695e71255a5a577377afe28af5457752.jpg";